import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var stretch_full_width_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M5 4h14v11H5V4Zm11 16H8v-1.5h8V20Z" }) });
export {
  stretch_full_width_default as default
};
//# sourceMappingURL=stretch-full-width.js.map
